import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import Loader from './../shared/loader'
import apiUrl from '../../../constants';
import axios from 'axios';
import packingApis from '../packingb2b/packingb2b'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import Pagination from './../shared/pagination'
import csvHelper from '../reports/importjsontocsv';
import printpackdata from './printpackdata'
import awaitEach from 'await-each'
import Vue from 'vue';
import vSelect from 'vue-select'


export default {
	name: 'Packing',
	components: {
		Loader,
		Multiselect,
		DatePicker,
		Pagination,
		printpackdata,
		awaitEach,
		vSelect
	},

	data: function () {
		return {
			boxdatas: [],
			tabIndex: 0,
			orignalpendingqty: 0,
			ispackingbuttonenable: true,
			addotherscourier: false,
			showeye1: true,
			ClientErr: '',
			warehouse: '',
			hideediticon: false,
			showclosebutton: false,
			showerrorCouriercompany: true,
			resultCompleteBoxPacking: [],
			ismanualPackingEnable: false,
			disableQcbutton: false,
			pageLimit: 10,
			totalRows: 0,
			currentPage: 1,
			listb2bQcdone: [],
			listb2bBoxlist: [],
			isweightsaved: false,
			boxid1: '',
			searchFlag: false,
			AddshipmentDetail: false,
			orderProdList: [],
			formattedDate: '',
			listInventorySyncData: [],
			isLoading: false,
			isLoadingFeild: false,
			css1: true,
			css2: false,
			css3: false,
			showButtonManualPacking: false,
			listWarehouseData: [],
			systemLoginCheck: false,
			showBoxInputs: false,
			showBoxDetails: false,
			showProductQcDetails: false,
			isProductReject: false,
			allowPackingComplete: false,
			rejectReasons: [],
			showInvoiceAndLabels: true,
			options: [],
			token: '',
			showQCAndPackingSection: true,
			showPackingCompleteButton: false,
			salesChannelList: [],
			showSplitBoxData: false,
			sourceBoxData: [],
			destinationBoxData: [],
			destinationBoxId: '',
			showSplitButton: false,
			destinationProductID: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			specialInstructionModel:false,
            specialInstructionList:[],
            specialInstructionCount:0,
			specialInstructionButton:false,
			finalObject: {
				warehouseId: '',
				boxId: '',
				boxWeight: 0,
				clientName: '',
				salesChannel: '',
				orderId: '',
				totalSkus: '',
				orderShiByDate: '',
				shipmentId: '',
				productId: '',
				boxStatus: '',
				orderStatus: '',
				clientId: '',
				scanproductData: '',
				rejectReasons: '',
				userEmail: '',
				salesChannelList: [],
				courierName: '',
				OthercourierName: '',
				awbNo: '',
				showInvoiceButton: false,
				showLabelButton: false,
				normalOrder: false,
				isRubicon: false,
				isWmall: false,
				isUnicommerce: false,
				isMultiseller: false,
				isNimbus: false,
				isincreff:false,
				cancelProductDetails: [],
				orderType: '',
				sellerName: '',
				totalOrderQty: '',
				userId: '',
				shippingLabel: '',
				invoiceLabel: '',
				shippingCode: '',
				orderTypeInput: '',
				shipmentStatus: '',
				merchantName: '',
				xbEcomFlag: false,
				xbEcomAwbNo: '',
				xbEcomCourierCompany: '',
				orderSelfshipped: '',
				productQty: '',
				showQtyInput: false,
				qcQtyPending: '',
				weight: 0
			},
			Qccomplete: {
				client: '',
				warehouse: '',
				orderid: '',
				Shipbyfromdate: '',
				Shipbytodate: '',
				ordercreatedfromdate: '',
				ordercreatedtodate: '',
				boxweight: '',
				b2b_qc_done: '',
				remainingqty: ''
			},
			addinvoicedetails: {
				invoiceno: '',
				value: '',
				ewaybill: '',
				isInvoiceDetailssaved: false,
			},
			addshipdetails: {
				orderId: '',
				totalboxes: 0,
				orderweight: 0
			},
			totalPage: 0,
			totalboxes: 0,
			editweight: false,
			res_client: '',
			res_warehouse: '',
			shippingCourierCompany: null,
			shippingProviderFinal: null,
			isReadonlyFlag:1,
			lastShipmentInputTime: Date.now(),
            isScanningForShipment: false,
            scanTimeoutForShipment: null,
		}
	},
	filters: {
		moment: function (date) {
			if (date)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
			else {
				return '';
			}
		},
	},
	computed: {
		isComplete() {
			var isComplete = this.addinvoicedetails.invoiceno && this.addinvoicedetails.value && this.ispackingbuttonenable
			return isComplete;
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
		var plaintext = bytes.toString(CryptoJS.enc.Utf8)
		var userdetail = JSON.parse(plaintext)
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.user_type = userdetail.utype
		this.finalObject.userEmail = userdetail.email
		this.finalObject.userId = userdetail.userid
		this.userid = userdetail.userid
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.checkEancodeFlag();
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getBoxDetails()
		}
		switch (this.user_type) {
			case 'system_user':
				this.systemLoginCheck = true
				// this.getWarehouseList()
				// this.getClientList()
				this.showSelectClient = true
				this.showSelectWarehouse = true
				break

			case 'client_user':
				this.$alert(this.$t('common.unauthorisedError'))
				break

			case 'warehouse_user':
				// this.getClientList()
				this.Qccomplete.warehouse = this.finalObject.warehouseId = userdetail.warehouseid
				this.showBoxInputs = true
				this.showSelectClient = true
				this.showSelectWarehouse = false
				break

			default:
				this.$alert(this.$t('common.unauthorisedError'))
				break
		}
	},

	methods: {
		detectKeyPressEventupdate(event) {
			if(this.isReadonlyFlag == 0)
			{
				let currentTime = Date.now();
			// Ignore Enter (13) and Tab (9)
			if (event.keyCode === 13 || event.keyCode === 9) {
				return;
			}

			// First input detected (reset state)
			if (this.lastShipmentInputTime === null) {
				this.lastShipmentInputTime = currentTime;
				this.isScanningForShipment = true; // Assume scanner initially
			}

			let timeDiff = currentTime - this.lastShipmentInputTime;
			// If input is very fast, assume scanner is active
			if (timeDiff <= 50) {
				this.isScanningForShipment = true;
			} else {
				this.isScanningForShipment = false;
			}
			this.lastShipmentInputTime = currentTime;

			// Set a timeout to detect when the scan is complete
			clearTimeout(this.scanTimeoutForShipment);
			
			this.scanTimeoutForShipment = setTimeout(() => {
				if (this.isScanningForShipment && this.finalObject.productId.length > 5) {
				return this.$refs.checkProductid.focus();
				} else {
				this.finalObject.productId = "";
				return this.$alert('Scan the barcode, manual entry not allowed');
				}
			}, 50); // Adjust timing based on your scanner speed
			}
			else{
				return true
			}
        },
		async checkEancodeFlag(){
            let inputPayload = {
                clientid:localStorage.getItem("selectedClient"),
                warehouseid: Number(window.localStorage.getItem("selectedWarehouse")),
            }
                let response = await packingApis.getEancodeFlag(inputPayload, this.token)
                    if (response.data.errorCode == 0) {            
                        if(this.user_type !== 'system_user'){
                            this.isReadonlyFlag = response.data.data.eancodeFlag;
                        }
                    }
        },
		onPageChange(page) {
			this.currentPage = page;
			this.getb2bQcdonelisting()
		},
		dateFormatDetail(date) {
			if (!date) return ''
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		closeModal() {
			this.modalShow = false
		},
		callParent1() {
			this.showeye1 = true;
		},
		getBoxDatas() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				'clientid': localStorage.getItem("selectedClient"),
				'warehouseid': localStorage.getItem("selectedWarehouse"),
				'boxid': this.finalObject.boxId,
				'orderid': this.finalObject.orderId
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'packing/getBoxData',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {

						this.boxdatas = result.data.data.data.boxData
					}
				});
		},
		closeAddshipdetails() {
			this.AddshipmentDetail = false;
			this.editweight = false;
			this.ismanualPackingEnable = false
			this.addotherscourier = false
			this.addinvoicedetails.isInvoiceDetailssaved = false;
			this.showclosebutton = false
			this.ispackingbuttonenable = true
			this.showInvoiceAndLabels = true
			this.finalObject.showInvoiceButton = false
			this.finalObject.showLabelButton = false
			this.hideediticon = false
			this.editweight = false

			if (this.addinvoicedetails.value != "") {
				document.getElementById("value").value = ""
			}
			if (this.addinvoicedetails.invoiceno != "") {
				document.getElementById("invoiceno").value = ""
			}
			if (this.addinvoicedetails.ewaybill != "") {
				document.getElementById("ewaybill").value = ""
			}
			if (this.finalObject.awbNo != "") {
				document.getElementById("awbno").value = ""
			}
			document.getElementById('invoiceno').disabled = false
			document.getElementById('value').disabled = false
			document.getElementById('ewaybill').disabled = false
			document.getElementById('awbno').disabled = false
			document.getElementById('couriername').disabled = false

			this.getb2bQcdonelisting()
		},
		manualPackingEnable() {
			var checkbox = document.getElementById("manualPackingEnable").checked
			if (checkbox) {
				this.ismanualPackingEnable = true
				this.finalObject.salesChannelList = this.salesChannelList
				document.getElementById('awbno').disabled = false
				document.getElementById('couriername').disabled = false
				document.getElementById("manualPackingEnable").disabled = true
				this.showInvoiceAndLabels = false
				this.finalObject.showInvoiceButton = false
				this.finalObject.showLabelButton = false
				this.finalObject.courierName = ''
				this.finalObject.awbNo = ''
				this.$validator.reset()

			}
		},

		// warehouseSelected() {
		// 	this.finalObject.boxId = ''
		// 	if (this.finalObject.warehouseId) {
		// 		this.showBoxInputs = true
		// 	}
		// },
		// getWarehouseListbyclient() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		'clientid': this.Qccomplete.client,
		// 	});
		// 	axios({
		// 		method: 'POST',
		// 		'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 		'data': this.input,
		// 		headers: {
		// 			'Authorization': 'Bearer ' + myStr
		// 		}
		// 	})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = this.totalPage = 0;

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;

		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// async getWarehouseList() {
		// 	try {
		// 		this.isLoading = true
		// 		let result = await packingApis.getWarehouseList(this.token)
		// 		this.listWarehouseData = result.data.data
		// 		this.isLoading = false
		// 	} catch (err) {
		// 		console.log(err)
		// 		this.isLoading = false
		// 	}
		// },

		async getWeight() {
			try {
				this.isLoading = true
				let weightResponse = await packingApis.getWeight(this.token)
				this.isLoading = false
				if (weightResponse.status == 200 && weightResponse.data.weight) {
					this.finalObject.boxWeight = parseFloat(weightResponse.data.weight)
				} else {
					this.$alert(this.$t('boxList.weighingMachineError'))
					this.finalObject.boxWeight = 0
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},
		adddetails() {
			this.Qccomplete.client = this.finalObject.clientId
			this.Qccomplete.warehouse = this.finalObject.warehouseId
			this.Qccomplete.orderid = this.finalObject.orderId
			this.getb2bQcdonelisting()

		},
		async AddshipmentDetails(data, client, warehouse) {
			await this.clearshipdata()
			this.AddshipmentDetail = true;
			this.addshipdetails.orderId = data.order_id
			this.addshipdetails.totalboxes = data.boxes
			document.getElementById("invoiceno").value = data.invoicenumber
			document.getElementById("value").value = data.invoicevalue
			document.getElementById("ewaybill").value = data.ewaybill
			this.addinvoicedetails.invoiceno = data.invoicenumber
			this.addinvoicedetails.value = data.invoicevalue
			this.addinvoicedetails.ewaybill = data.ewaybill
			if (data.invoicevalue != null && data.ewaybill != null && data.invoicenumber != null) {
				this.addinvoicedetails.isInvoiceDetailssaved = true;
			}
			this.Qccomplete.client = client
			this.Qccomplete.warehouse = warehouse
			let resultboxid = await this.getBoxDetailsb2b()
			this.addshipdetails.orderweight = data.orderweight == 0 ? resultboxid.orderweight : data.orderweight
			this.getBoxDetails(this.Qccomplete.warehouse, this.boxid1)
		},
		async clearshipdata() {
			this.addinvoicedetails.value = ''
			this.addinvoicedetails.invoiceno = ''
			this.addinvoicedetails.ewaybill = ''
			this.finalObject.awbNo = ''
			this.finalObject.courierName = ''
			this.addshipdetails.orderweight = 0;
			this.addshipdetails.totalboxes = 0;
			this.addshipdetails.orderId = ''
			this.boxid1 = ''
			this.$validator.reset()
		},
		async getBoxDetails(warehouse, boxid) {

			try {
				if (warehouse != undefined && boxid != undefined) {
					this.finalObject.warehouseId = warehouse;
					this.finalObject.boxId = boxid;
				}
				else if (this.finalObject.boxId < 1) {
					return false
				}
				this.cleanForm()
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId
				}
				let boxId = this.finalObject.boxId
				this.isLoading = true
				let response = await packingApis.getBoxDetails(inputPayload, this.token)
				let data = response.data.data.data
				if (response.data.data.ErrorCode == 0) {
					this.showPackingCompleteButton = true
					this.finalObject.merchantName = data.merchantName
					this.finalObject.clientName = data.clientName
					this.finalObject.orderId = data.orderId
					this.finalObject.salesChannel = data.salesChannel
					this.finalObject.totalSkus = data.totalSkus
					this.finalObject.totalQty = data.totalQty
					this.finalObject.totalOrderQty = data.totalOrderQty
					this.finalObject.cancelQty = data.cancelQty
					this.finalObject.qtyQcAccept = data.qtyQcAccept
					this.finalObject.qtyQcReject = data.qtyQcReject
					this.finalObject.orderShiByDate = data.orderShiByDate
					this.finalObject.shipmentId = data.shipmentId
					this.finalObject.boxStatus = data.boxStatus
					this.finalObject.orderStatus = data.orderStatus
					this.finalObject.orderSelfshipped = data.orderSelfshipped
					this.finalObject.clientId = data.clientId
					this.Qccomplete.boxweight = data.weight == "" ? 0 : data.weight
					this.Qccomplete.b2b_qc_done = data.b2b_qc_done
					this.Qccomplete.remainingqty = data.remainingqty
					this.finalObject.sellerName = data.sellerName
					if (Number(this.finalObject.cancelQty) > 0) {
						this.finalObject.cancelProductDetails = data.cancelProductDetails
					}
					this.css2 = true
					this.css1 = false
					this.showBoxDetails = true
					this.finalObject.salesChannelList = data.salesChannelList
					this.salesChannelList = data.salesChannelList
					this.options = data.rejectQCReasons
					if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0) {
						this.showQCAndPackingSection = false
					} else {
						this.showQCAndPackingSection = true
					}
					if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) {
						this.allowPackingComplete = true
					}
					this.finalObject.normalOrder = data.normalOrder
					this.finalObject.isNimbus = data.isNimbus
					this.finalObject.isRubicon = data.isRubicon
					this.finalObject.isWmall = data.isWmall
					this.finalObject.isUnicommerce = data.isUnicommerce
					this.finalObject.isMultiseller = data.isMultiseller
					this.finalObject.isincreff = data.isIncreff
					this.finalObject.xbEcomFlag = data.xbEcomFlag
					this.finalObject.xbEcomAwbNo = data.xbEcomAwbNo
					this.finalObject.xbEcomCourierCompany = data.xbEcomCourierCompany
					this.finalObject.showLabelButton = data.showLabelButton
					this.finalObject.showInvoiceButton = data.showInvoiceButton
					this.finalObject.shippingCourierCompany = null;
					this.finalObject.shippingProviderFinal = null
					if(this.finalObject.boxStatus == 'in_packing'){
                        this.finalObject.awbNo =data.awbNoPacking;
                        this.finalObject.courierName = data.shippingCompany;
                        if(data.shippingCompany)
                        {
                            this.finalObject.salesChannelList.push({
                                'courierid': data.shippingCompany,
                                'couriername': data.shippingCompany
                            })
                        }
                        document.addEventListener('DOMContentLoaded', function() {
                            document.getElementById('awbno').disabled = true
                            document.getElementById('couriername').disabled = true
                        })              
                    }
					if (this.showeye1 == true) {
						this.getBoxDatas()
					}
					if (this.finalObject.xbEcomFlag) {
						this.finalObject.courierName = this.finalObject.xbEcomCourierCompany
						this.finalObject.salesChannelList = []
						this.finalObject.salesChannelList.push({
							'courierid': this.finalObject.xbEcomCourierCompany,
							'couriername': this.finalObject.xbEcomCourierCompany
						})
						this.finalObject.awbNo = this.finalObject.xbEcomAwbNo
						this.showInvoiceAndLabels = false
						if (this.finalObject.isRubicon) {
							this.finalObject.orderTypeInput = 'isRubicon'
							this.finalObject.orderType = 'Rubicon'
						} else if (this.finalObject.isWmall) {
							this.finalObject.orderTypeInput = 'isWmall'
							this.finalObject.orderType = 'Wmall'
						} else if (this.finalObject.isMultiseller) {
							this.finalObject.orderTypeInput = 'isMultiseller'
							this.finalObject.orderType = 'Flipkart'
						} else if (this.finalObject.isUnicommerce) {
							this.finalObject.orderTypeInput = 'isUnicommerce'
							this.finalObject.orderType = 'Unicommerce'
						} else {
							this.finalObject.orderTypeInput = 'isNormal'
							this.finalObject.orderType = 'CSV'
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awbno').value = this.finalObject.awbNo
						}
						document.getElementById('awbno').disabled = true
						document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isRubicon) {
						this.showInvoiceAndLabels = true
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.salesChannelList = []
						this.finalObject.salesChannelList.push({
							'courierid': this.finalObject.courierName,
							'couriername': this.finalObject.courierName
						})
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.orderTypeInput = 'isRubicon'
						this.finalObject.orderType = 'Rubicon'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.courierName != 'Amazon') {
							document.getElementById('awbno').disabled = true
						} else {
							this.finalObject.awbNo = ''
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awbno').value = this.finalObject.awbNo
						}
						document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isWmall) {

						this.showInvoiceAndLabels = true
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.salesChannelList = []
						this.finalObject.salesChannelList.push({
							'courierid': this.finalObject.courierName,
							'couriername': this.finalObject.courierName
						})
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.orderTypeInput = 'isWmall'
						this.finalObject.orderType = 'Wmall'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awbno').value = this.finalObject.awbNo
						}
						document.getElementById('awbno').disabled = true
						document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isMultiseller) {

						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.salesChannelList = []
						this.finalObject.salesChannelList.push({
							'courierid': this.finalObject.courierName,
							'couriername': this.finalObject.courierName
						})
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.orderTypeInput = 'isMultiseller'
						this.finalObject.orderType = 'Flipkart'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awbno').value = this.finalObject.awbNo
						}
						document.getElementById('awbno').disabled = true
						document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isUnicommerce) {

						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.shippingCourierCompany = data.shippingCourierCompany
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.salesChannelList = []
						if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
							this.finalObject.salesChannelList.push({
								'courierid': this.finalObject.shippingCourierCompany,
								'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
							});
							this.finalObject.shippingProviderFinal = this.finalObject.courierName;
							this.finalObject.courierName = this.finalObject.shippingCourierCompany;
						} else {
							this.finalObject.salesChannelList.push({
								'courierid': this.finalObject.courierName,
								'couriername': this.finalObject.courierName
							})
						}
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.shippingCode = data.shippingCode
						this.finalObject.orderTypeInput = 'isUnicommerce'
						this.finalObject.orderType = 'Unicommerce'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awbno').value = this.finalObject.awbNo
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						document.getElementById('awbno').disabled = true
						document.getElementById('couriername').disabled = true
					} else if (this.finalObject.isNimbus) {

						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.salesChannelList = []
						this.finalObject.salesChannelList.push({
							'courierid': this.finalObject.courierName,
							'couriername': this.finalObject.courierName
						})
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.orderTypeInput = 'isNimbus'
						this.finalObject.orderType = 'Nimbus'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						if (this.finalObject.awbNo != '') {
							document.getElementById('awbno').value = this.finalObject.awbNo
						}
						if (this.finalObject.courierName != '') {
							document.getElementById('couriername').value = this.finalObject.courierName
						}
						document.getElementById('awbno').disabled = true
						document.getElementById('couriername').disabled = true
					} else if (this.finalObject.normalOrder) {
						this.finalObject.orderTypeInput = 'isNormal'
						this.showInvoiceAndLabels = false
						this.finalObject.orderType = 'CSV'

					}else if (this.finalObject.isincreff) {
						this.showInvoiceAndLabels = true
						this.finalObject.courierName = data.shippingCourierCompany
						this.finalObject.shippingCourierCompany = data.shippingCourierCompany
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.salesChannelList = []
						if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
							this.finalObject.salesChannelList.push({
								'courierid': this.finalObject.shippingCourierCompany,
								'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
							});
							this.finalObject.shippingProviderFinal = this.finalObject.courierName;
							this.finalObject.courierName = this.finalObject.shippingCourierCompany;
						} else {
							this.finalObject.salesChannelList.push({
								'courierid': this.finalObject.courierName,
								'couriername': this.finalObject.courierName
							})
						}
						this.finalObject.shippingLabel = data.labelUrl
						this.finalObject.invoiceLabel = data.invoiceUrl
						this.finalObject.shippingCode = data.shippingCode
						this.finalObject.orderTypeInput = 'isIncreff'
						this.finalObject.orderType = 'Increff'
						if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
							this.showButtonManualPacking = true
							this.css1 = false
							this.css2 = false
							this.css3 = true
						}
						Vue.nextTick(() => {
						document.getElementById('awbno').disabled = true
						document.getElementById('couriername').disabled = true
						})
					}
					document.getElementById('boxid').disabled = true

				} else {

					this.Qccomplete.b2b_qc_done = data.b2b_qc_done
					this.showPackingCompleteButton = false
					this.showQCAndPackingSection = false
					if (data.isBoxValid) {
						this.showInvoiceAndLabels = true
						this.allowPackingComplete = true
						this.finalObject.salesChannelList.push({
							'courierid': data.shippingCompany,
							'couriername': data.shippingCompany
						})
						this.finalObject.courierName = data.shippingCompany
						this.finalObject.shipmentStatus = data.shipmentStatus
						this.finalObject.merchantName = data.merchantName
						this.finalObject.awbNo = data.awbNoPacking
						this.finalObject.clientName = data.clientName
						this.finalObject.orderId = data.orderId
						this.finalObject.salesChannel = data.salesChannel
						this.finalObject.totalQty = data.totalQty
						this.finalObject.cancelQty = data.cancelQty
						if (Number(this.finalObject.cancelQty) > 0) {
							this.finalObject.cancelProductDetails = data.cancelProductDetails
						}
						this.finalObject.totalOrderQty = data.totalOrderQty
						this.finalObject.orderShiByDate = data.orderShiByDate
						this.finalObject.shipmentId = data.shipmentId
						this.finalObject.boxStatus = data.boxStatus
						this.finalObject.orderStatus = data.orderStatus
						this.finalObject.orderSelfshipped = data.orderSelfshipped
						this.finalObject.clientId = data.clientId
						this.css2 = true
						this.css1 = false
						this.showBoxDetails = true
						this.finalObject.sellerName = data.sellerName
						this.finalObject.normalOrder = data.normalOrder
						this.finalObject.isNimbus = data.isNimbus
						this.finalObject.xbEcomFlag = data.xbEcomFlag
						this.finalObject.isRubicon = data.isRubicon
						this.finalObject.isWmall = data.isWmall
						this.finalObject.isUnicommerce = data.isUnicommerce
						this.finalObject.isMultiseller = data.isMultiseller
						this.finalObject.showLabelButton = data.showLabelButton
						this.finalObject.showInvoiceButton = data.showInvoiceButton
						if (this.finalObject.isRubicon) {
							this.finalObject.orderTypeInput = 'isRubicon'
							this.finalObject.orderType = 'Rubicon'
						} else if (this.finalObject.isWmall) {
							this.finalObject.orderTypeInput = 'isWmall'
							this.finalObject.orderType = 'Wmall'
						} else if (this.finalObject.isMultiseller) {
							this.finalObject.orderTypeInput = 'isMultiseller'
							this.finalObject.orderType = 'Flipkart'
						} else if (this.finalObject.isUnicommerce) {
							this.finalObject.orderTypeInput = 'isUnicommerce'
							this.finalObject.orderType = 'Unicommerce'
						} else if (this.finalObject.isNimbus) {
							this.finalObject.shippingLabel = data.labelUrl
							this.finalObject.invoiceLabel = data.invoiceUrl
							this.finalObject.orderTypeInput = 'isNimbus'
							this.finalObject.orderType = 'Nimbus'
						} else if (this.finalObject.normalOrder) {
							this.finalObject.orderTypeInput = 'isNormal'
							this.finalObject.orderType = 'CSV'
						}
						else if (this.finalObject.isincreff) {
							this.finalObject.orderTypeInput = 'isIncreff'
							this.finalObject.orderType = 'Increff'
						}
						document.getElementById('boxid').disabled = true
					} else {
						this.showInvoiceAndLabels = false
						document.getElementById('boxid').value = null
						this.finalObject.boxId = ""
					}
					this.$alert(response.data.data.msg, boxId)
				}
				this.isLoading = false
				await this.checkEancodeFlag();
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
			finally{
				if(this.finalObject.salesChannel!==""){
					this.getSpecialInstruction()
				} 
			} 
		},

		cleanForm() {
			this.isLoading = false
			this.isLoadingFeild = false
			this.salesChannelList = []
			this.css1 = true
			this.css2 = false
			this.css3 = false
			this.showButtonManualPacking = false
			this.showBoxDetails = false
			this.showProductQcDetails = false
			this.isProductReject = false
			this.allowPackingComplete = false
			this.rejectReasons = []
			this.showInvoiceAndLabels = true
			this.options = []
			this.showPackingCompleteButton = false
			this.showQCAndPackingSection = false
			this.finalObject.boxWeight = 0
			this.finalObject.clientName = ''
			this.finalObject.salesChannel = ''
			this.finalObject.orderId = ''
			this.finalObject.totalSkus = ''
			this.finalObject.orderShiByDate = ''
			this.finalObject.shipmentId = ''
			this.finalObject.productId = ''
			this.finalObject.productQty = ''
			this.finalObject.showQtyInput = false
			this.finalObject.qcQtyPending = ''
			this.finalObject.boxStatus = ''
			this.finalObject.orderStatus = ''
			this.finalObject.clientId = ''
			this.finalObject.scanproductData = ''
			this.finalObject.rejectReasons = ''
			this.finalObject.salesChannelList = []
			this.finalObject.courierName = ''
			this.finalObject.awbNo = ''
			this.finalObject.showInvoiceButton = false
			this.finalObject.showLabelButton = false
			this.finalObject.normalOrder = false
			this.finalObject.isNimbus = false
			this.finalObject.isRubicon = false
			this.finalObject.isWmall = false
			this.finalObject.isUnicommerce = false
			this.finalObject.isMultiseller = false
			this.finalObject.cancelProductDetails = []
			this.finalObject.orderType = ''
			this.finalObject.sellerName = ''
			this.finalObject.totalOrderQty = ''
			this.finalObject.shippingLabel = ''
			this.finalObject.invoiceLabel = ''
			this.finalObject.shippingCode = ''
			this.finalObject.orderTypeInput = ''
			this.finalObject.shipmentStatus = ''
			this.finalObject.merchantName = ''
			this.showSplitBoxData = false
			this.sourceBoxData = []
			this.destinationBoxData = []
			this.destinationBoxId = ''
			this.destinationProductID = ''
			this.showSplitButton = false
			this.finalObject.orderSelfshipped = ''
		},
		resetFormlisting() {
			// this.Qccomplete.client = ''
			if (this.user_type != "warehouse_user") {
				// this.Qccomplete.warehouse = ''
			}
			this.Qccomplete.orderid = ''
			this.Qccomplete.ordercreatedfromdate = ''
			this.Qccomplete.ordercreatedtodate = ''
			this.Qccomplete.Shipbyfromdate = ''
			this.Qccomplete.Shipbytodate = ''
			this.listb2bQcdone = []
			this.totalRows = 0
			this.searchFlag = false
		},

		resetForm() {
			if (this.systemLoginCheck) {
				// this.finalObject.warehouseId = ''
				this.$validator.reset()
			}
			if (this.showeye1 == true) {
				// this.getWarehouseList()
			}
			this.finalObject.xbEcomFlag = ''
			this.finalObject.xbEcomAwbNo = ''
			this.finalObject.xbEcomCourierCompany = false
			this.showSplitBoxData = false
			this.sourceBoxData = []
			this.destinationBoxData = []
			this.destinationBoxId = ''
			this.showSplitButton = false
			this.destinationProductID = ''
			this.isLoading = false
			this.isLoadingFeild = false
			this.salesChannelList = []
			this.css1 = true
			this.css2 = false
			this.css3 = false
			this.showButtonManualPacking = false
			this.showBoxDetails = false
			this.showProductQcDetails = false
			this.isProductReject = false
			this.allowPackingComplete = false
			this.rejectReasons = []
			this.showInvoiceAndLabels = true
			this.options = []
			this.showPackingCompleteButton = false
			this.showQCAndPackingSection = false
			this.finalObject.boxId = ''
			this.finalObject.boxWeight = 0
			this.finalObject.clientName = ''
			this.finalObject.salesChannel = ''
			this.finalObject.orderId = ''
			this.finalObject.totalSkus = ''
			this.finalObject.orderShiByDate = ''
			this.finalObject.shipmentId = ''
			this.finalObject.productId = ''
			this.finalObject.productQty = ''
			this.finalObject.showQtyInput = false
			this.finalObject.qcQtyPending = ''
			this.finalObject.boxStatus = ''
			this.finalObject.orderStatus = ''
			this.finalObject.clientId = ''
			this.finalObject.scanproductData = ''
			this.finalObject.rejectReasons = ''
			this.finalObject.salesChannelList = []
			this.finalObject.courierName = ''
			this.finalObject.awbNo = ''
			this.finalObject.showInvoiceButton = false
			this.finalObject.showLabelButton = false
			this.finalObject.normalOrder = false
			this.finalObject.isNimbus = false
			this.finalObject.isRubicon = false
			this.finalObject.isWmall = false
			this.finalObject.isUnicommerce = false
			this.finalObject.isMultiseller = false
			this.finalObject.cancelProductDetails = []
			this.finalObject.orderType = ''
			this.finalObject.sellerName = ''
			this.finalObject.totalOrderQty = ''
			this.finalObject.shippingLabel = ''
			this.finalObject.invoiceLabel = ''
			this.finalObject.shippingCode = ''
			this.finalObject.orderTypeInput = ''
			this.finalObject.shipmentStatus = ''
			this.finalObject.merchantName = ''
			this.finalObject.orderSelfshipped = ''
			document.getElementById('boxid').value = null
			document.getElementById('boxid').disabled = false
			document.getElementById('productid').disabled = false
			document.getElementById('productid').value = false
			document.getElementById('awbno').disabled = false
			document.getElementById('awbno').value = false
			document.getElementById('couriername').disabled = false
			document.getElementById('couriername').value = false
			document.getElementById("manualPackingEnable").disabled = false
			document.getElementById('destinationBoxId').value = null
			document.getElementById('destinationBoxId').disabled = false
			this.$validator.reset()
		},

		async scanProduct() {
			try {
				this.isProductReject = false
				this.showProductQcDetails = false
				this.finalObject.productQty = ''
				this.finalObject.showQtyInput = false
				this.finalObject.qcQtyPending = ''
				if (!this.finalObject.productId) {
					this.$alert(this.$t('common.productIdError'))

				}
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId,
					clientid: localStorage.getItem("selectedClient"),
					orderid: this.finalObject.orderId,
					productid: this.finalObject.productId.trim()
				}
				this.isLoadingFeild = true
				let response = await packingApis.scanProductPacking(inputPayload, this.token)
				let data = response.data.data.data
				let productId = this.finalObject.productId.trim()
				if (response.data.data.ErrorCode == 0) {
					this.finalObject.scanproductData = response.data.data.data
					this.showProductQcDetails = true
					document.getElementById('productid').disabled = true
					if (response.data.data.data.resultConfigBulkPickingPacking.status && Number(response.data.data.data.qcQtyPending) >= Number(response.data.data.data.resultConfigBulkPickingPacking.limit)) {
						this.finalObject.showQtyInput = true
						this.finalObject.qcQtyPending = Number(response.data.data.data.qcQtyPending)
						this.orignalpendingqty = this.finalObject.qcQtyPending

					}
				} else {
					this.finalObject.qcQtyPending = ''
					this.finalObject.productId = ''
					this.finalObject.productQty = ''
					this.finalObject.showQtyInput = false
					this.$alert(response.data.data.msg, productId)
					document.getElementById('productid').disabled = false
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		productQC(obj) {
			if (obj == "reject") {
				this.isProductReject = true
			} else {
				this.updateQcDetails(obj)
			}
		},

		async updateQcDetails(obj) {
			try {
				if (obj == 'reject' && this.finalObject.rejectReasons.length < 1) {
					this.$alert(this.$t('boxList.rejectReasonError'))
					return false
				}

				if (this.finalObject.showQtyInput && Number(this.finalObject.qcQtyPending) != Number(this.finalObject.productQty)) {
					if (Number(this.finalObject.qcQtyPending) > Number(this.finalObject.productQty)) {
						this.$alert(this.$t('boxList.pickedQtyLessError'))
					} else {
						this.$alert(this.$t('boxList.pickedQtyGreaterError'))
					}
					return false
				}
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId,
					clientid: localStorage.getItem("selectedClient"),
					orderid: this.finalObject.orderId,
					productid: this.finalObject.productId.trim(),
					qcstatus: obj,
					rejectreasons: obj == "reject" ? this.finalObject.rejectReasons : [],
					useremail: this.finalObject.userEmail,
					productqty: this.finalObject.showQtyInput ? this.finalObject.productQty : '',
					btoborder:1
				}
				this.isLoadingFeild = true
				let response = await packingApis.updateQcDetails(inputPayload, this.token)
				let data = response.data.data.data
				if (response.data.data.ErrorCode == 0) {
					this.finalObject.rejectReasons = []
					this.rejectReasons = []
					this.finalObject.productId = ''
					this.finalObject.productQty = ''
					this.finalObject.showQtyInput = false
					this.finalObject.qcQtyPending = ''
					this.finalObject.scanproductData = {}
					this.finalObject.qtyQcAccept = data.totalQCAcceptQty
					this.finalObject.qtyQcReject = data.totalQCRejectQty
					this.isProductReject = false
					this.showProductQcDetails = false
					if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0) {
						this.showQCAndPackingSection = false
					} else {
						this.showQCAndPackingSection = true
					}
					if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) {
						this.allowPackingComplete = true
						this.showPackingCompleteButton = true
						if (this.finalObject.isRubicon || this.finalObject.isWmall || this.finalObject.isMultiseller || this.finalObject.isUnicommerce) {
							document.getElementById('awbno').disabled = true
							if (this.finalObject.courierName == 'Amazon' && this.finalObject.isRubicon) {
								document.getElementById('awbno').disabled = false
								this.finalObject.awbNo = ''
							}
							document.getElementById('couriername').disabled = true
						}
					}
					this.$alertify.success(response.data.data.msg)
					document.getElementById('productid').disabled = false
				} else {
					this.$alert(response.data.data.msg, this.finalObject.productId.trim())
					document.getElementById('productid').disabled = false
					return false
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		rejectedReasonsSelected() {
			let isOther = this.rejectReasons.map(el => el.value).includes("Other")
			if (isOther) {
				this.$prompt("Enter Reject Reason").then(text => {
					if (text && text != '' && text != null) {
						this.rejectReasons.push({
							value: text.trim(),
							text: text.trim()
						})
						this.$alert(this.$t('boxList.rejectReasonMsg1'), text)
					} else {
						this.$alert(this.$t('boxList.rejectReasonMsg2'), text)
					}
				})
			}
			this.finalObject.rejectReasons = this.rejectReasons.map(el => el.value)
		},

		// completePacking() {
		// 	if (!this.finalObject.awbNo || !this.finalObject.courierName) {
		// 		this.$validator.validateAll()
		// 		return false
		// 	} else {
		// 		if (Number(this.finalObject.cancelQty) > 0) {
		// 			this.$confirm("Please RackIn Cancelled Products").then((confirm) => {
		// 				if (confirm) {
		// 					// this.completeBoxPacking()
		// 				}
		// 			})
		// 		} else {
		// 			// this.completeBoxPacking()
		// 		}
		// 	}
		// },

		async printInvoice() {
			try {
				if (this.finalObject.isRubicon) {
					this.isLoading = true
					let inputPayload = {
						clientid: this.finalObject.clientId,
						shipmentid: this.finalObject.shipmentId,
						orderid: this.finalObject.orderId,
						sellername: this.finalObject.sellerName
					}
					let result = await packingApis.getrubiconInvoiceAndLabel(inputPayload, this.token)
					if (result.data.data.ErrorCode == 0) {
						if (result.data.data.data.invoice_document_external_url) {
							this.windowOpen(result.data.data.data.invoice_document_external_url)
						} else {
							this.$alert(result.data.data.msg)
						}
					} else {
						this.$alert(result.data.data.msg)
					}
					this.isLoading = false
				} else if (this.finalObject.isUnicommerce) {
					if (this.showPackingCompleteButton) {
						//this.windowOpen(this.finalObject.invoiceLabel)
						//alert("hi2")
						//window.open("data:application/pdf;base64, " + this.finalObject.invoiceLabel);
						//	let newdata = "data:application/pdf;base64, " + this.finalObject.invoiceLabel;
						var newWindow = window.open();
						newWindow.document.write('<iframe src="data:application/pdf;base64,' + (this.finalObject.invoiceLabel) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
						newWindow.document.title = "Invoice-" + this.finalObject.orderId;


					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							saleschannel: this.finalObject.salesChannel //passed sales channel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							var newWindow = window.open();
							newWindow.document.write('<iframe src="data:application/pdf;base64,' + (result.data.data.data.data.invoicelabel) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
							newWindow.document.title = "Invoice-" + this.finalObject.orderId;
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isMultiseller) {
					if (this.showPackingCompleteButton) {
						this.getInvoiceAndLabelFlipkart(1)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							shipmentid: this.finalObject.shipmentId,
							orderid: this.finalObject.orderId
						}
						let result = await packingApis.getFlipkartInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.finalObject.shippingLabel = result.data.data.data.data
							this.finalObject.invoiceLabel = result.data.data.data.data
							this.getInvoiceAndLabelFlipkart(1)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isWmall) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.invoiceLabel)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							saleschannel: this.finalObject.salesChannel //passed sales channel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.windowOpen(result.data.data.data.data.invoicelabel)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isNimbus) {
					this.windowOpen(this.finalObject.invoiceLabel)
				} else if (this.finalObject.normalOrder) {
					this.printInvoiceWMS()
				} else if (this.finalObject.isincreff) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.invoiceLabel)
					}
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},

		async printLabel() {
			try {
				if (this.finalObject.xbEcomFlag) {
					this.printLabelWMS()
				} else if (this.finalObject.isRubicon) {
					this.isLoading = true
					let inputPayload = {
						clientid: this.finalObject.clientId,
						shipmentid: this.finalObject.shipmentId,
						orderid: this.finalObject.orderId,
						sellername: this.finalObject.sellerName
					}
					let result = await packingApis.getrubiconInvoiceAndLabel(inputPayload, this.token)
					if (result.data.data.ErrorCode == 0) {
						if (result.data.data.data.shipping_label_document_external_url) {
							this.windowOpen(result.data.data.data.shipping_label_document_external_url)
						} else {
							this.$alert(result.data.data.msg)
						}
					} else {
						this.$alert(result.data.data.msg)
					}
					this.isLoading = false
				} else if (this.finalObject.isUnicommerce) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.shippingLabel)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							////passed sales channel
							saleschannel: this.finalObject.salesChannel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.windowOpen(result.data.data.data.data.shippinglabel)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isMultiseller) {
					if (this.showPackingCompleteButton) {
						this.getInvoiceAndLabelFlipkart(2)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							shipmentid: this.finalObject.shipmentId,
							orderid: this.finalObject.orderId
						}
						let result = await packingApis.getFlipkartInvoiceAndLabel(inputPayload, this.token)
						this.isLoading = false
						if (result.data.data.ErrorCode == 0) {
							this.finalObject.shippingLabel = result.data.data.data.data
							this.finalObject.invoiceLabel = result.data.data.data.data
							this.getInvoiceAndLabelFlipkart(2)
						} else {
							this.$alert(result.data.data.msg)
						}
					}
				} else if (this.finalObject.isWmall) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.shippingLabel)
					} else {
						this.isLoading = true
						let inputPayload = {
							clientid: localStorage.getItem("selectedClient"),
							warehouseid: localStorage.getItem("selectdedWarehouse"),
							orderid: this.finalObject.orderId,
							shipmentid: this.finalObject.shipmentId,
							saleschannel: this.finalObject.salesChannel //passed sales channel
						}
						let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
						if (result.data.data.ErrorCode == 0) {
							this.windowOpen(result.data.data.data.data.shippinglabel)
						} else {
							this.$alert(result.data.data.msg)
						}
						this.isLoading = false
					}
				} else if (this.finalObject.isNimbus) {
					this.windowOpen(this.finalObject.shippingLabel)
				} else if (this.finalObject.normalOrder) {
					this.printLabelWMS()
				} else if (this.finalObject.isincreff) {
					if (this.showPackingCompleteButton) {
						this.windowOpen(this.finalObject.shippingLabel)
					}
				}
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},
		PrintPackdata(data) {
			this.selectedRow = data
			this.showeye1 = false;
		},
		async printInvoiceWMS() {
			try {
				this.isLoading = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
					awbno: this.finalObject.awbNo,
					shippingcompany: this.finalObject.courierName
				}
				let resultInvoiceWms = await packingApis.getInvoiceWMS(inputPayload, this.token)
				if (resultInvoiceWms.status) {
					let invoiceData = resultInvoiceWms.data.printData.invoiceData.replace("/n", "")
					var myWindow = window.open("", "MsgWindow", "_blank")
					setTimeout(function () {
						myWindow.document.write(invoiceData)
					}, 2000)
					myWindow.document.title = 'TaxInvoice'
					setTimeout(function () {
						myWindow.print()
					}, 4000)
				} else {
					this.$alert(this.$t('boxList.invoiceURLError'))
				}
				this.isLoading = false
			} catch (err) {
				console.log(err)
				this.isLoading = false
			}
		},

		getInvoiceAndLabelFlipkart(obj) { //stream object function
			let filename = this.finalObject.orderId + ".pdf"
			let data = ""
			if (obj == 1) {
				filename = "Invoice" + this.finalObject.orderId + ".pdf"
				data = this.finalObject.invoiceLabel
			} else {
				filename = "Label" + this.finalObject.orderId + ".pdf"
				data = this.finalObject.shippingLabel
			}
			let a = document.createElement("a");
			a.href = "data:application/octet-stream;base64," + data;
			a.download = filename
			a.click();
		},

		printLabelWMS() {
			let routeData = this.$router.resolve({
				name: 'shippinglabel',
				params: {
					"clientid": localStorage.getItem("selectedClient"),
					"warehouseid": localStorage.getItem("selectedWarehouse"),
					"awbno": this.finalObject.awbNo,
					"orderid": this.finalObject.orderId,
					"shippingcompany": this.finalObject.courierName
				},
				query: {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					awbno: this.finalObject.awbNo,
					orderid: this.finalObject.orderId,
					shippingcompany: this.finalObject.courierName,
				},
			})
			this.windowOpen(routeData.href)
		},

		windowOpen(obj) {
			window.open(obj, '_blank')
		},

		courierSelected() {
			if (this.finalObject.courierName && this.finalObject.courierName == 'Others') {
				this.addotherscourier = true
				this.showerrorCouriercompany = false;
				this.finalObject.courierName = ''
			} else {
				this.addotherscourier = false
			}
		},
		saveOtherCourier() {
			if (this.finalObject.OthercourierName && this.finalObject.OthercourierName != '' && this.finalObject.OthercourierName != null && this.finalObject.OthercourierName != undefined) {
				this.finalObject.OthercourierName = this.finalObject.OthercourierName.replace(/^.{1}/g, this.finalObject.OthercourierName[0].toUpperCase())
				this.finalObject.salesChannelList.push({
					'courierid': this.finalObject.OthercourierName.trim(),
					'couriername': this.finalObject.OthercourierName.trim()
				})
				this.finalObject.courierName = this.finalObject.OthercourierName.trim()
				this.$alert(this.$t('boxList.courierCompanyMsg1'), this.finalObject.OthercourierName)
				this.addotherscourier = false;
			} else {
				this.$alert(this.$t('boxList.courierCompanyMsg2'), this.finalObject.OthercourierName)
			}
		},
		splitBox() {
			if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) > 1) {
				this.showSplitBoxData = true
				this.destinationBoxId = ''
				this.destinationProductID = ''
				this.showSplitButton = false
				this.getSplitBoxDetails()
				document.getElementById('destinationBoxId').disabled = false
				document.getElementById('destinationBoxId').value = null
			} else {
				this.$alert(this.$t('boxList.boxSplitError'))
				return false
			}
		},

		async getSplitBoxDetails() {
			try {
				this.sourceBoxData = []
				this.destinationBoxData = []
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
				}
				let resultSplitBoxDetails = await packingApis.getSplitBoxDetails(inputPayload, this.token)
				if (resultSplitBoxDetails.data.data.ErrorCode == 0) {
					resultSplitBoxDetails.data.data.data.forEach((el) => {
						if (el.boxid == this.finalObject.boxId) {
							this.sourceBoxData.push(el)
						} else {
							this.destinationBoxData.push(el)
						}
					})
				} else {
					this.$alert(resultSplitBoxDetails.data.data.msg)
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		async validateBox() {
			try {
				if (this.destinationBoxId < 1) {
					return false
				}
				if (Number(this.destinationBoxId) == Number(this.finalObject.boxId)) {
					this.$alert(this.$t('boxList.boxIDError'), this.destinationBoxId)
					this.destinationBoxId = ''
					document.getElementById('destinationBoxId').value = null
					return false
				}
				this.isLoadingFeild = true
				let boxId = this.destinationBoxId
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
					boxid: this.destinationBoxId,
					userid: this.finalObject.userId,
					shipmentid: this.finalObject.shipmentId
				}
				let resultValidateBox = await packingApis.validateBox(inputPayload, this.token)
				if (resultValidateBox.data.data.ErrorCode == 0 && resultValidateBox.data.data.data) {
					this.$alertify.success(resultValidateBox.data.data.msg)
					document.getElementById('destinationBoxId').disabled = true
					this.showSplitButton = true
				} else {
					this.destinationBoxId = ''
					this.showSplitButton = false
					document.getElementById('destinationBoxId').value = null
					this.$alert(resultValidateBox.data.data.msg, boxId)
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		async saveWeight() {
			try {
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId,
					weight: this.Qccomplete.boxweight
				}
				let resultSplitBoxPacking = await packingApis.saveWeight(inputPayload, this.token)
				if (resultSplitBoxPacking.data.data.ErrorCode == 0) {
					this.isweightsaved = true
					this.$alertify.success(resultSplitBoxPacking.data.data.msg)
					// this.getBoxDetails()
				} else {
					this.$alert(resultSplitBoxPacking.data.data.msg)
				}

				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},
		async saveOrderWeight() {
			try {
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.addshipdetails.orderId,
					weight: this.addshipdetails.orderweight
				}
				let resultSaveOrderweight = await packingApis.saveOrderWeight(inputPayload, this.token)
				if (resultSaveOrderweight.data.data.ErrorCode == 0) {
					this.editweight = false
					// this.$alertify.success(resultSaveOrderweight.data.data.msg)
				} else {
					this.editweight = false
					this.$alert(resultSaveOrderweight.data.data.msg)
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},
		async saveinvoicedetails() {
			try {
				this.isLoadingFeild = true

				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.addshipdetails.orderId,
					invoicenumber: this.addinvoicedetails.invoiceno,
					ewaybill: this.addinvoicedetails.ewaybill != null ? this.addinvoicedetails.ewaybill : "",
					invoicevalue: this.addinvoicedetails.value
				}
				let resultSaveOrderweight = await packingApis.addinvoicedetails(inputPayload, this.token)
				if (resultSaveOrderweight.data.data.ErrorCode == 0) {
					// this.$alertify.success(resultSaveOrderweight.data.data.msg)
					this.addinvoicedetails.isInvoiceDetailssaved = true
				} else {
					this.$alert(resultSaveOrderweight.data.data.msg)
					this.addinvoicedetails.isInvoiceDetailssaved = false
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},


		async splitBoxProducts() {
			try {
				this.isLoadingFeild = true
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.finalObject.orderId,
					newboxid: this.destinationBoxId,
					userid: this.finalObject.userId,
					shipmentid: this.finalObject.shipmentId,
					boxid: this.finalObject.boxId,
					productid: this.destinationProductID,
					useremail: this.finalObject.userEmail,
				}
				let resultSplitBoxPacking = await packingApis.splitBoxPacking(inputPayload, this.token)
				if (resultSplitBoxPacking.data.data[0].ErrorCode == 0) {
					this.$alertify.success(resultSplitBoxPacking.data.data[0].msg)
					this.getBoxDetails()
				} else {
					this.$alert(resultSplitBoxPacking.data.data[0].msg, this.destinationProductID)
					this.destinationProductID = ''
					document.getElementById('destinationProductID').value = null
				}
				this.isLoadingFeild = false
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},

		async getb2bQcdonelisting(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.searchFlag = true
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.listb2bQcdone = []
				this.searchFlag = false
				this.isLoading = false;
				return false
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.listb2bQcdone = []
				this.searchFlag = false
				this.isLoading = false;
				return false
			}
			let inputPayload = {
				limit: this.pageLimit,
				offset: (this.currentPage - 1) * 1,
				pono: this.Qccomplete.orderid,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromDateFlt: this.dateFormatDetail(this.Qccomplete.ordercreatedfromdate),
				toDateFlt: this.dateFormatDetail(this.Qccomplete.ordercreatedtodate),
				fromDateFltStatus: this.dateFormatDetail(this.Qccomplete.Shipbyfromdate),
				toDateFltStatus: this.dateFormatDetail(this.Qccomplete.Shipbytodate),

			};

			let resultb2b = await packingApis.b2bQclisting(inputPayload, this.token)
			if (resultb2b.data.data.ErrorCode == -1) {
				this.listb2bQcdone = [];
				this.totalRows = 0
				this.isLoading = false;

			} else {
				this.listb2bQcdone = resultb2b.data.data
				this.totalRows = resultb2b.data.count
				this.res_client = resultb2b.data.clientid
				this.res_warehouse = resultb2b.data.warehouseid

				if (this.totalRows > 0) {
					if (this.totalRows <= this.pageLimit) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
					}
				}
				this.isLoading = false;
			}
		},
		markorderpacked() {
			if (!this.finalObject.awbNo || !this.finalObject.courierName) {
				if (!this.finalObject.courierName && this.ismanualPackingEnable == false) {
					this.$alertify.error("courier company is required")
				}
				if (!this.finalObject.awbNo && this.ismanualPackingEnable == false) {
					this.$alertify.error("Awb no is required")
				}
				if(this.finalObject.awbNo.indexOf(' ') >= 0)
			    {
				    this.$alert(this.$t('common.awbError'))
				    return false;
			    }
				this.$validator.validateAll()
				return false;
			} else {
				if(this.finalObject.awbNo.indexOf(' ') >= 0)
			    {
				    this.$alert(this.$t('common.awbError'))
				    return false;
			    }
				if (this.addinvoicedetails.invoiceno == "" || this.addinvoicedetails.invoiceno == null) {
					this.$alert(this.$t('boxList.invoiceNoError'))
					return false
				}
				if (this.addinvoicedetails.value == "" || this.addinvoicedetails.value == null) {
					this.$alert(this.$t('boxList.invoiceValueError'))
					return false
				}
				const that = this
				this.isLoading = true
				this.ispackingbuttonenable = false
				awaitEach(this.listb2bBoxlist, async function (item) {
					await that.completeBoxPacking(item)
				}).then(async (result) => {
					await this.saveinvoicedetails()
					await this.saveOrderWeight()
					this.$alertify.success(this.resultCompleteBoxPacking.data.data.msg)
					document.getElementById('awbno').disabled = true
					document.getElementById('couriername').disabled = true
					document.getElementById('invoiceno').disabled = true
					document.getElementById('value').disabled = true
					document.getElementById('ewaybill').disabled = true
					this.showInvoiceAndLabels = true
					this.finalObject.showInvoiceButton = true
					this.finalObject.showLabelButton = true
					this.hideediticon = true
					this.editweight = false
					this.showclosebutton = true
					this.isLoading = false
				})
			}
		},
		completeBoxPacking(item) {
			return new Promise(async (resolve, reject) => {
				try {
					let inputPayload = {
						clientid: localStorage.getItem("selectedClient"),
						warehouseid: localStorage.getItem("selectedWarehouse"),
						orderid: this.finalObject.orderId,
						awbno: this.finalObject.awbNo,
						shippingcompany: this.finalObject.courierName,
						boxid: item.boxid,
						useremail: this.finalObject.userEmail,
						userid: this.finalObject.userId,
						boxweight: item.weight,
						shippinglabel: this.finalObject.shippingLabel,
						invoicelabel: this.finalObject.shippingLabel,
						shippingcode: this.finalObject.shippingCode,
						ordertype: this.finalObject.orderTypeInput,
						saleschannel: this.finalObject.salesChannel,
						xbecomflag: this.finalObject.xbEcomFlag,
						shippingprovider: this.finalObject.shippingProviderFinal ? this.finalObject.shippingProviderFinal : '',

					}
					this.resultCompleteBoxPacking = await packingApis.completeBoxPacking(inputPayload, this.token)
					if (this.resultCompleteBoxPacking.data.data.ErrorCode == 0) {
						this.finalObject.boxStatus = 'in_shipping'
						this.finalObject.orderStatus = 'packed'
						this.showPackingCompleteButton = false
						this.showQCAndPackingSection = false
						this.showInvoiceAndLabels = true
						resolve({
							"status": true,
						})
					} else {
						this.$alert(this.resultCompleteBoxPacking.data.data.msg, this.finalObject.boxId)
						resolve({
							"status": false,
						})
					}
				} catch (err) {
					console.log(err)
				}
			})
		},

		async changeBoxStatus() {
			try {
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					boxid: this.finalObject.boxId,
					orderid: this.finalObject.orderId
				}
				let resultChangestatus = await packingApis.changeBoxStatus(inputPayload, this.token)

				if (resultChangestatus.data.msg == 1) {
					if (this.Qccomplete.remainingqty > 0) {
						this.Qccomplete.remainingqty = this.Qccomplete.remainingqty - 1;
					}
					this.Qccomplete.b2b_qc_done = 2;
					this.$alertify.success("Box Qc done successfully")
				} else {
					this.$alertify.error("Box Qc failed to mark")
					if (this.Qccomplete.remainingqty > 0) {
						this.resetForm()
					}
				}
			} catch (err) {
				console.log(err)
				this.isLoadingFeild = false
			}
		},
		getSpecialInstructionModal(){
            this.specialInstructionModel=true;
        },
		async getSpecialInstruction(){
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
			this.isLoading=true;
            await axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getSpecialPackingInstruction',
              'data': {
                clientid: window.localStorage.getItem('selectedClient'),
				saleschannel:this.finalObject.salesChannel
                },
              headers: {
                'Authorization': 'Bearer ' + myStr,
              },
               })
               .then((response) => {
                this.specialInstructionList = Array.isArray(response.data.data.data) ? response.data.data.data : [];
                this.specialInstructionCount=this.specialInstructionList.length;
				if(this.specialInstructionCount>0){
                    this.specialInstructionButton=true;
                }else{
                    this.specialInstructionButton=false;
                }
				this.isLoading=false;
               })
               .catch((httpException) => {
                 console.error('exception is:::::::::', httpException)
               }); 
         },
        closeSpecialInstructionModal(){
            this.specialInstructionModel=false;
        },
		async getBoxDetailsb2b(csvCheck) {
			return new Promise(async (resolve, reject) => {

				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				var dataFilter = {};
				this.searchFlag = true
				let inputPayload = {
					warehouseid: localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient"),
					orderid: this.addshipdetails.orderId
				};
				Object.entries(inputPayload).forEach(([k, v]) => {
					let skipkeys = [];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						dataFilter[k] = v;
					}
				})
				let resultb2b = await packingApis.b2bpackedboxlisting(inputPayload, this.token)
				this.listb2bBoxlist = resultb2b.data.data.data
				if (this.listb2bBoxlist.length > 0) {
					if (csvCheck == 1) {
						this.csvFields = {
							'b2b_qc_done': this.$t('boxList.b2bQcDone'),
							'order_id': this.$t('common.orderID'),
							'totalboxquantity': this.$t('common.totalQuantity'),
							'boxid': this.$t('common.boxId'),
							'weight': this.$t('boxList.weight'),
							'length': this.$t('boxList.length'),
							'width': this.$t('boxList.width'),
							'height': this.$t('boxList.height'),
						}

						var dateFilter = [];
						var skipFilter = ['b2b_qc_done', 'order_id'];
						csvHelper.data.jsonToCSV( this.$t('boxList.boxListingFileName'), this.listb2bBoxlist, this.csvFields, dateFilter, skipFilter, dataFilter);
					} else {
						var orderweight = 0;
						this.listb2bBoxlist.filter(function (el) {
							orderweight = orderweight + parseInt(el.weight);
						});

						this.boxid1 = resultb2b.data.data.data[0].boxid
						resolve({
							"boxid": this.boxid1,
							"orderweight": orderweight
						})
					}
				} else {
					resolve({
						"boxid": "",
						"orderweight": 0
					})
				}
			})
		},
	}

}



// WEBPACK FOOTER //
// ./src/views/components/packingb2b/packingb2b.component.js